import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogRef as MatDialogRef } from '@angular/material/dialog';

@Component({
    standalone: false,
    selector: 'noa-deployment-news-dialog',
    templateUrl: './dialog-deployment-news.component.html',
    styleUrls: ['./dialog-deployment-news.component.scss'],
})
export class DialogDeploymentNewsComponent implements OnInit {

    constructor(
        public dialogRef: MatDialogRef<DialogDeploymentNewsComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {}

    ngOnInit(): void {

    }

}
